export const AppServerIP =
  // process.env.NODE_ENV !== "production"
  // ? "http://localhost:8080/"
  // : // "http://52.79.210.53:8080/";
  "https://api.aone-ivis.com/";
//   : "http://3.36.105.75:8080/";
//"http://172.26.0.28:8080/";
export const loginURL = AppServerIP + "login/";
export const registerURL = AppServerIP + "register/";
